/*************************************************/
/* IMAGE-ACCORDION                               */
/*************************************************/

export function imageAccordion() {
    const imageAccordionContainerSelector = ".image-accordion__images-container";
    const imageAccordionelector = ".image-accordion__image";
    const accordionImageActiveClass = "image-accordion__image--active";
    const accordionImageFallbackClass = "image-accordion__image--fallback";
    const accordionActivateItemEventName = 'activateItem';

    const init = () => {
        const imageContainers = document.querySelectorAll(imageAccordionContainerSelector);
        if (imageContainers) {
            imageContainers.forEach(container => {
                const images = container.querySelectorAll(imageAccordionelector);
                if (images[1].classList.contains(accordionImageActiveClass)) {
                    images[0].classList.remove(accordionImageActiveClass);
                }

                container.addEventListener(accordionActivateItemEventName, e => {
                    let i = 0;
                    container.querySelectorAll(imageAccordionelector).forEach(image => {
                        image.classList.remove(accordionImageActiveClass);
                        if (image.classList.contains(accordionImageFallbackClass)) return;
                        if (i == e.detail.accordionItemIndex) {
                            image.classList.add(accordionImageActiveClass);
                        }
                        i++;
                    });
                });
            });
        }
    };

    init();
}